export default "__VITE_ASSET__Bsia7ZSW__"